import { retrieveToken } from '../storage';
import {
  wrapFetch,
  wrapFetchWithDetailedErrors,
  apiFetch,
  apiError,
  SALVATAGGIO_DATI_NON_CORRETTI,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getBrands = (page, size, sortby, brandId, brandNome) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/brand';
  let query = `?page=${page}&size=${size}&sort=${sortby}&${sortby}.dir=ASC`;

  if (brandId) {
    query += `&id.equals=${brandId}`;
  }
  if (brandNome) {
    query += `&nome.contains=${encodeURIComponent(brandNome)}`;
  }

  let URL = BASE_URL + PATH + query;

  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
    }),
    apiError(),
  );
};

export const getBrandCount = (brandId, brandNome) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/brand/count';
  let query = `?`;

  if (brandId) {
    query += `&id.equals=${brandId}`;
  }
  if (brandNome) {
    query += `&nome.contains=${encodeURIComponent(brandNome)}`;
  }

  let URL = BASE_URL + PATH + query;

  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
    }),
    apiError(),
  );
};

export const getBrand = (brandId) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = `/api/brand/${brandId}`;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
    }),
    apiError({
      404: "Caricamento dati fallito: nessun brand corrispondente all'ID indicato.",
    }),
  );
};

export const getBrandByPath = (path) => {
  const token = retrieveToken();
  const PATH = '/api/brand/by-path';
  // The path arrives as the first segment of window.location, so it can hold
  // characters that are legal there but not in a query: `carrefour&x` would
  // otherwise be sent as `?path=carrefour&x` and read as `carrefour`, serving one
  // brand's identity to another brand's URL. URLSearchParams escapes them, so an
  // invalid segment answers 404 instead.
  const query = `?${new URLSearchParams({ path }).toString()}`;
  const URL = BASE_URL + PATH + query;

  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers,
    }),
    apiError({
      404: 'Caricamento dati fallito: nessun brand corrispondente al path indicato.',
    }),
  );
};

export const getLogoByPath = (path) => {
  const token = retrieveToken();
  const PATH = '/api/brand/by-path/logo';
  const query = `?${new URLSearchParams({ path }).toString()}`;
  const URL = BASE_URL + PATH + query;

  // Endpoint pubblico: Authorization solo se il token c'è (vedi getBrandByPath).
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers,
    }),
    apiError({
      404: 'Caricamento dati fallito: logo non trovato per brand con path indicato.',
    }),
  );
};

export const getLogoLeftByPath = (path) => {
  const token = retrieveToken();
  const PATH = '/api/brand/by-path/logo-left';
  const query = `?${new URLSearchParams({ path }).toString()}`;
  const URL = BASE_URL + PATH + query;

  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers,
    }),
    apiError({
      404: 'Caricamento dati fallito: logo non trovato per brand con path indicato.',
    }),
  );
};

export const getLogoApp = (brandId) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = `/api/brand/app/${brandId}/logo`;
  const URL = BASE_URL + PATH;

  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
        // "Content-Type": "application/json",
      },
    }),
    apiError({
      404: 'Caricamento dati fallito: logo app non trovato per brand con ID indicato.',
    }),
  );
};

export const createBrand = (formData) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/brand';
  const URL = BASE_URL + PATH;

  return wrapFetchWithDetailedErrors(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        // "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
      credentials: 'include',
      body: formData,
    }),
    apiError({
      400: 'Registrazione del brand non riuscita: dati non corretti.',
      409: 'Registrazione del brand non riuscita: esiste già un brand registrato con gli stessi dati.',
    }),
  );
};

export const updateBrand = (formData) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = `/api/brand/style`;
  const URL = BASE_URL + PATH;

  return wrapFetchWithDetailedErrors(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        // "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
      credentials: 'include',
      body: formData,
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: SALVATAGGIO_DATI_NON_CORRETTI,
      409: 'Salvataggio non riuscito: esiste già un brand con questo nome.',
    }),
  );
};
